import { Spin, BackTop } from 'antd';
import classNames from 'classnames';
import parse from 'html-react-parser';

import months from '../../Shared/months.json';

import useQuery from '../../../../util/useQuery';
import TableCookie from './TableCookie';

export default function PreviewArticle({
    lang,
    detail,
    mode,
    loading,
    logo,
    cookieList,
}) {
    const params = useQuery();
    const cookiePolicy = detail?.cookiePolicy;
    const cookieIntroductionLawfulBasis = detail?.cookieIntroductionLawfulBasis;
    const cookieAreUsed = detail?.cookieAreUsed;
    const cookiePreferences = detail?.cookiePreferences;
    const cookiePolicyChange = detail?.cookiePolicyChange;

    const formatMonth = (month) => {
        const item = months.find((res) => res.id === month + 1);
        return lang === 'TH' ? item?.monthTh : item?.monthEn;
    };

    const formatYear = (year) => {
        return lang === 'TH' ? year + 543 : year;
    };

    const getCurrentDate = (date) => {
        const updateDate = date?.split(' ')[0];
        const dateItem = `${updateDate?.split('/')[1]}/${
            updateDate?.split('/')[0]
        }/${updateDate?.split('/')[2]}`;
        const currentDate = new Date(dateItem);
        const day = currentDate?.getDate();
        const month = formatMonth(Number(currentDate.getMonth()));
        const year = formatYear(Number(currentDate.getFullYear()));
        const formatDate = `${day} ${month} ${year}`;
        return formatDate;
    };

    const allCheck = (category) => {
        let check = category?.filter((res) => res?.isEnable);
        return check?.length;
    };

    return (
        <Spin spinning={loading}>
            <div
                className={classNames({
                    'rounded-md py-4 pl-4 pr-2 w-full border-1 max-w-4xl my-4 mx-auto bg-white':
                        !params.get('ember'),
                    'm-0 w-full !border-none ': params.get('ember') === '1',
                })}
                style={{ border: '1px solid #DBDBDB' }}
            >
                <div>
                    <div className="px-2">
                        <article className="prose max-w-full text-left">
                            <div className="text-center">
                                {cookiePolicy?.cookieCompanyLogoId && (
                                    <img
                                        className="w-auto h-28 rounded-lg object-cover m-0"
                                        src={logo}
                                        alt={
                                            lang === 'TH'
                                                ? cookiePolicy?.cookiePolicyNameTh
                                                : cookiePolicy?.cookiePolicyNameEn
                                        }
                                    />
                                )}
                                <h3>
                                    {lang === 'TH'
                                        ? cookiePolicy?.cookiePolicyNameTh
                                        : cookiePolicy?.cookiePolicyNameEn}
                                </h3>
                                {cookieIntroductionLawfulBasis?.cookieIntroductionIsDisplay && (
                                    <p className="text-left">
                                        {parse(
                                            `${
                                                lang === 'TH'
                                                    ? cookieIntroductionLawfulBasis?.cookieIntroductionContentTh ||
                                                      '-'
                                                    : cookieIntroductionLawfulBasis?.cookieIntroductionContentEn ||
                                                      '-'
                                            }`
                                        )}
                                    </p>
                                )}
                            </div>
                            {/* cookieIntroductionLawfulBasis */}
                            {cookieIntroductionLawfulBasis?.cookieWhatAreIsDisplay && (
                                <>
                                    <h4>
                                        {lang === 'TH'
                                            ? cookieIntroductionLawfulBasis?.cookieWhatAreTitleTh
                                            : cookieIntroductionLawfulBasis?.cookieWhatAreTitleEn}
                                    </h4>
                                    <p className="text-left">
                                        {parse(
                                            `${
                                                lang === 'TH'
                                                    ? cookieIntroductionLawfulBasis?.cookieWhatAreContentTh ||
                                                      '-'
                                                    : cookieIntroductionLawfulBasis?.cookieWhatAreContentEn ||
                                                      '-'
                                            }`
                                        )}
                                    </p>
                                </>
                            )}
                            {cookieIntroductionLawfulBasis?.cookieBenefitIsDisplay && (
                                <>
                                    <h4>
                                        {lang === 'TH'
                                            ? cookieIntroductionLawfulBasis?.cookieBenefitTitleTh
                                            : cookieIntroductionLawfulBasis?.cookieBenefitTitleEn}
                                    </h4>
                                    <p className="text-left">
                                        {parse(
                                            `${
                                                lang === 'TH'
                                                    ? cookieIntroductionLawfulBasis?.cookieBenefitContentTh ||
                                                      '-'
                                                    : cookieIntroductionLawfulBasis?.cookieBenefitContentEn ||
                                                      '-'
                                            }`
                                        )}
                                    </p>
                                </>
                            )}
                            {/* cookieAreUsed */}
                            {cookieAreUsed?.cookieHowDoIsDisplay && (
                                <>
                                    <h4>
                                        {lang === 'TH'
                                            ? cookieAreUsed?.cookieHowDoTitleTh
                                            : cookieAreUsed?.cookieHowDoTitleEn}
                                    </h4>
                                    <p className="text-left">
                                        {parse(
                                            `${
                                                lang === 'TH'
                                                    ? cookieAreUsed?.cookieHowDoContentTh ||
                                                      '-'
                                                    : cookieAreUsed?.cookieHowDoContentEn ||
                                                      '-'
                                            }`
                                        )}
                                    </p>
                                </>
                            )}
                            {cookieAreUsed?.cookieWhatTypeIsDisplay && (
                                <>
                                    <h4>
                                        {lang === 'TH'
                                            ? cookieAreUsed?.cookieWhatTypeTitleTh
                                            : cookieAreUsed?.cookieWhatTypeTitleEn}
                                    </h4>
                                    <div>
                                        {cookieList &&
                                        cookieList?.cookieCategoryList?.length >
                                            0 &&
                                        allCheck(
                                            cookieList?.cookieCategoryList
                                        ) ? (
                                            <>
                                                {cookieList?.cookieCategoryList?.map(
                                                    (val) => (
                                                        <div
                                                            hidden={
                                                                !val?.isEnable
                                                            }
                                                            className="mb-3"
                                                        >
                                                            <p className="text-[#65707A] font-semibold">
                                                                •{' '}
                                                                {lang === 'TH'
                                                                    ? val?.cookieCategoryNameTh
                                                                    : val?.cookieCategoryNameEn}
                                                            </p>
                                                            <p className="text-[#65707A]">
                                                                {lang === 'TH'
                                                                    ? val?.descriptionTh
                                                                    : val?.descriptionEn}
                                                            </p>
                                                            <TableCookie
                                                                lang={lang}
                                                                listCookie={
                                                                    val?.cookieList ||
                                                                    []
                                                                }
                                                            />
                                                        </div>
                                                    )
                                                )}
                                            </>
                                        ) : (
                                            <>-</>
                                        )}
                                    </div>
                                </>
                            )}
                            {/* cookiePreferences */}
                            {cookiePreferences?.cookieSettingIsDisplay && (
                                <>
                                    <h4>
                                        {lang === 'TH'
                                            ? cookiePreferences?.cookieSettingTitleTh
                                            : cookiePreferences?.cookieSettingTitleEn}
                                    </h4>
                                    <p className="text-left">
                                        {parse(
                                            `${
                                                lang === 'TH'
                                                    ? cookiePreferences?.cookieSettingContentTh ||
                                                      '-'
                                                    : cookiePreferences?.cookieSettingContentEn ||
                                                      '-'
                                            }`
                                        )}
                                    </p>
                                </>
                            )}
                            {cookiePreferences?.cookieThirdPartyIsDisplay && (
                                <>
                                    <h4>
                                        {lang === 'TH'
                                            ? cookiePreferences?.cookieThirdPartyTitleTh
                                            : cookiePreferences?.cookieThirdPartyTitleEn}
                                    </h4>
                                    <p className="text-left">
                                        {parse(
                                            `${
                                                lang === 'TH'
                                                    ? cookiePreferences?.cookieThirdPartyContentTh ||
                                                      '-'
                                                    : cookiePreferences?.cookieThirdPartyContentEn ||
                                                      '-'
                                            }`
                                        )}
                                    </p>
                                </>
                            )}
                            {/* cookiePolicyChange */}
                            {cookiePolicyChange?.cookieChangeIsDisplay && (
                                <>
                                    <h4>
                                        {lang === 'TH'
                                            ? cookiePolicyChange?.cookieChangeTitleTh
                                            : cookiePolicyChange?.cookieChangeTitleEn}
                                    </h4>
                                    <p className="text-left">
                                        {parse(
                                            `${
                                                lang === 'TH'
                                                    ? cookiePolicyChange?.cookieChangeContentTh ||
                                                      '-'
                                                    : cookiePolicyChange?.cookieChangeContentEn ||
                                                      '-'
                                            }`
                                        )}
                                    </p>
                                </>
                            )}
                            {cookiePolicyChange?.cookieDataControllerIsDisplay && (
                                <>
                                    <h4>
                                        {lang === 'TH'
                                            ? cookiePolicyChange?.cookieDataControllerTitleTh
                                            : cookiePolicyChange?.cookieDataControllerTitleEn}
                                    </h4>
                                    <p className="text-left">
                                        {parse(
                                            `${
                                                lang === 'TH'
                                                    ? cookiePolicyChange?.cookieDataControllerContentTh ||
                                                      '-'
                                                    : cookiePolicyChange?.cookieDataControllerContentEn ||
                                                      '-'
                                            }`
                                        )}
                                    </p>
                                </>
                            )}
                            {cookiePolicyChange?.cookieDataProtectionIsDisplay && (
                                <>
                                    <h4>
                                        {lang === 'TH'
                                            ? cookiePolicyChange?.cookieDataProtectionTitleTh
                                            : cookiePolicyChange?.cookieDataProtectionTitleEn}
                                    </h4>
                                    <p className="text-left">
                                        {parse(
                                            `${
                                                lang === 'TH'
                                                    ? cookiePolicyChange?.cookieDataProtectionContentTh ||
                                                      '-'
                                                    : cookiePolicyChange?.cookieDataProtectionContentEn ||
                                                      '-'
                                            }`
                                        )}
                                    </p>
                                </>
                            )}
                            <h4>
                                {lang === 'TH'
                                    ? 'ฉบับ ณ วันที่'
                                    : 'Edition as of'}{' '}
                                {cookiePolicy?.effectiveDate
                                    ? getCurrentDate(
                                          cookiePolicy?.effectiveDate
                                      )
                                    : '-'}
                            </h4>
                        </article>
                    </div>
                </div>
            </div>
            <div hidden={!mode}>
                <BackTop style={{ zIndex: 100000 }}>
                    <div
                        className="flex items-center justify-center !bg-[#1890ff]"
                        style={style}
                    >
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                                fill="white"
                            />
                        </svg>
                    </div>
                </BackTop>
            </div>
        </Spin>
    );
}
const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#7B67FB',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};
